import React, { useState } from "react"
import PropTypes from "prop-types"
import { useNow } from "src/hooks"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import FieldSet from "@infotech/uikit-fieldset"
import { components } from "@infotech/uikit-select"
import cn from "classnames"
import InfinitySelect from "src/components/Selects/InfinitySelect"
import { updateList } from "src/engine/modules/lists/actions/creators/update"
import { selectCurrentList } from "src/engine/modules/lists/selectors"
import { useAvailableList } from "src/hooks/useAvailableList"
import {
  DEFAULT_COLOR,
  makeTransparent,
} from "src/containers/Calendar/helpers/eventToItem"
import { LIST_NAME, getBasicUrl } from "./helper"
import List from "./list"
import styles from "./styles.css"

const createFirstText = `Чтобы добавить типы событий, создайте тип плана.`

const EventTypeWrapper = ({ color, label }) => (
  <Box flex loose p="1md" className={styles.Option}>
    <Box loose className={styles.CircleWrapper}>
      <div
        className={styles.circle}
        style={{
          backgroundColor: `${
            color === `#fff` ? DEFAULT_COLOR : makeTransparent(color, 0.4)
          }`,
        }}
      />
    </Box>
    <Box pt="4px" loose className={cn(styles.SelectDropdownOptionLabel)}>
      {label}
    </Box>
  </Box>
)

EventTypeWrapper.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

const Option = ({ data, ...props }) => (
  <components.Option data={data} {...props}>
    <EventTypeWrapper {...data} />
  </components.Option>
)

const EventTypePart = ({
  planTypeEventTypeList,
  planType: { isVirtual, id },
  updateList,
  isDisabled,
}) => {
  const [availableQuery, setQuery] = useState({ limit: 30, offset: 0 })

  const [refreshTimestamp, refreshList] = useNow()
  const { data, pending } = useAvailableList({
    params: {
      url: `/plan/types/${id}/events/types/available`,
      body: availableQuery,
    },
    trigger: availableQuery,
    extraTrigger: Boolean(id) && !isVirtual,
    refresh: refreshTimestamp,
    hold: Boolean(id) && !isVirtual,
  })

  const eventTypeOptions = data.map(item => ({
    value: item.id,
    label: item.name,
    color: item.color,
    data: item,
  }))

  return (
    <Box loose>
      <Box loose pt="2md" pl="2md" pr="2md">
        <FieldSet caption="Типы событий">
          <div data-testid="plan-types-event-types-select">
            <InfinitySelect
              hideSelectedOptions
              isSearchable
              placeholder="Выберите типы событий"
              isDisabled={isVirtual || pending || isDisabled}
              isLoading={pending}
              options={eventTypeOptions}
              value={null}
              onChange={({ target: { value: option } }) => {
                updateList({
                  basicUrl: getBasicUrl(id),
                  name: LIST_NAME,
                  id: option.value,
                  item: option.data,
                })
                return null
              }}
              components={{ Option }}
              infinityConfig={{
                searchBy: `name`,
                changeQuery: setQuery,
                queryParams: availableQuery,
              }}
            />
          </div>
        </FieldSet>
      </Box>
      {isVirtual && (
        <Box pl="2md" className={styles.FirstCreateLabel}>
          {createFirstText}
        </Box>
      )}
      <Box pt="2md">
        {!isVirtual && id && (
          <List
            planTypeId={id}
            isLoading={pending}
            isVirtual={isVirtual}
            isDisabled={isDisabled}
            planTypeEventTypeList={planTypeEventTypeList}
            refreshList={refreshList}
          />
        )}
      </Box>
    </Box>
  )
}

EventTypePart.propTypes = {
  id: PropTypes.oneOf([`string`, `number`]).isRequired,
  isVirtual: PropTypes.bool.isRequired,
  planTypeEventTypeList: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  updateList: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default connect(
  state => ({
    planTypeEventTypeList: selectCurrentList(state, LIST_NAME),
  }),
  {
    updateList,
  },
)(EventTypePart)
